// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"shrink-horizontal"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M12 4V20M18.5 8.5L15 12L18.5 15.5M21.5 12H16.25M5.5 8.5L9 12L5.5 15.5M2.5 12H7.75","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ShrinkHorizontalIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'shrink-horizontal',
    ref,
    icon: element,
  },
));

ShrinkHorizontalIcon.displayName = 'ShrinkHorizontalIcon';

export default ShrinkHorizontalIcon;
